module.exports = __webpack_public_path__ + "img/MGH-Nakasu-8-2440x1172.e3b77a64.jpg";